import { useLocation } from "react-router-dom";
import { Container, Card, CardContent, Typography, Divider, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ReactComponent as IconEasyPayLogo } from '../../icons/epIconNew.svg';

const SuccessPayment = () => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const bankName = searchParams.get("bankName");
    const paymentId = searchParams.get("paymentId");

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundColor: "#f5f5f5",
            }}
        >
            <Card
                sx={{
                    textAlign: "center",
                    p: 4,
                    borderRadius: 3,
                    boxShadow: 4,
                }}
            >
                <Box
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mx: "auto",
                        mb: 2,
                    }}
                >
                    <CheckCircleOutlineIcon
                        sx={{
                            fontSize: 50,
                            color: "success.main",
                        }}
                    />
                </Box>
                <div style={{ marginBottom: "1rem" }}>
                    <IconEasyPayLogo style={{ height: 50 }} />
                </div>
                <Divider sx={{ my: 2 }} />
                <CardContent>
                    <Typography variant="h5" gutterBottom>
                        Kërkesa për rimbushje është aprovuar me sukses.
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Kthehuni në aplikacion për të vazhduar procesin.
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
};

export default SuccessPayment;
